import { render, staticRenderFns } from "./pre-sale-detail.vue?vue&type=template&id=168187c6&scoped=true&%3Aactive=showDialog&"
import script from "./pre-sale-detail.vue?vue&type=script&lang=js&"
export * from "./pre-sale-detail.vue?vue&type=script&lang=js&"
import style0 from "./pre-sale-detail.vue?vue&type=style&index=0&id=168187c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168187c6",
  null
  
)

export default component.exports